import { StreamateCamera } from "components/ads/StreamateCamera";
import { VisibleOnly } from "components/utils/VisibleOnly";
import "./StreamateCameraDispatcher.scss";

export const StreamateCameraDispatcher = () => {
  return (
    <VisibleOnly className="GifPreview StreamateCameraDispatcher">
      <StreamateCamera />
    </VisibleOnly>
  );
};
